// ============================================================
// web/src/features/devis/titreOperation.js
// Le titre d'une ligne de gamme : LE TRAVAIL, pas la case du modèle.
// ------------------------------------------------------------
// Il vit dans son propre module, sans dépendance à `@shared`, pour que
// le banc d'analyse statique de `garde-affichage.test.js` puisse
// l'importer. Une règle d'affichage qu'on ne peut pas tester parce
// qu'elle est enfermée dans un composant n'est pas testée.
// ============================================================

import { decouper } from '../../ui/Puces.jsx';

/**
 * Le titre d'une ligne : LE TRAVAIL, pas la case du modèle.
 *
 * ── Ce que Charles a vu chez ChatGPT — 26 août 2026 ──
 *
 * Une fiche produite par ChatGPT titrait « OP10 — Cubage du brut »,
 * « OP20 — Première face principale », « OP50 — Finition alésage de
 * précision ». La nôtre disait « OP 20 — production ».
 *
 * Le mot « production » ne décrit aucun travail : c'est notre
 * vocabulaire interne, celui qui dit comment le temps se multiplie. Il a
 * sa place — il est juste en dessous, avec la machine — mais pas en
 * titre. **Un titre nomme ce qu'on fait ; une catégorie dit comment on
 * le compte.**
 *
 * Le texte existe déjà : le champ `detail` porte « débit barreau
 * prismatique · longueur ~540 mm ». On en prend le premier fragment, et
 * on garde le numéro d'OP et la catégorie, qui distinguent les deux
 * lignes d'une même opération.
 */
export function titreDeLOperation(op) {
  const brut = String(op?.libelle ?? '').trim();
  const gabarit = /^OP\s*\d+\s*[—–-]\s*(prototype|production|contr[ôo]le(\s+\w+)?)$/i;
  const travail = decouper(op?.detail)[0];
  // Un libellé qui dit déjà le travail est conservé tel quel : le
  // remplacer par le détail perdrait ce que le deviseur a pu corriger.
  if (brut && !gabarit.test(brut)) return brut;
  if (!travail) return brut || '—';
  const numero = op?.op_num != null ? `OP ${op.op_num} — ` : '';
  return `${numero}${travail.charAt(0).toUpperCase()}${travail.slice(1)}`;
}

